import { routes } from '@/routes';
import homeIcon from '@/assets/sideBar/home.png';
import homeIconActive from '@/assets/sideBar/home_active.png';
import refundIcon from '@/assets/sideBar/refund.png';
import refundActiveIcon from '@/assets/sideBar/refund_active.png';
import refundHistoryIcon from '@/assets/sideBar/refund_history.png';
import refundHistoryIconActive from '@/assets/sideBar/refund_history_active.png';
import taxDataIcon from '@/assets/sideBar/tax_data.png';
import taxDataIconActive from '@/assets/sideBar/tax_data_active.png';
import hospitalInfoIcon from '@/assets/sideBar/hospital_info.png';
import hospitalInfoIconActive from '@/assets/sideBar/hospital_info_active.png';
import kioskIcon from '@/assets/sideBar/kiosk_setting.png';
import kioskIconActive from '@/assets/sideBar/kiosk_setting_active.png';
import IMG_GOODS_LEFLAT from '@/assets/sideBar/goods_leflat.png';
import IMG_GOODS_REFUND_TABLE from '@/assets/sideBar/goods_refund_table.png';
import IMG_GOODS_STICKER from '@/assets/sideBar/goods_sticker.png';
import IMG_GOODS_POP from '@/assets/sideBar/goods_pop.png';
import IMG_GOODS_ETC from '@/assets/sideBar/goods_etc.png';
import bookStatusIconActive from '@/assets/sideBar/book_status_active.png';
import bookStatusIconInactive from '@/assets/sideBar/book_status_inactive.png';
import qrIconActive from '@/assets/sideBar/QR_active.png';
import qrIconInactive from '@/assets/sideBar/QR_inactive.png';
import fxIconActive from '@/assets/sideBar/fx_active.png';
import fxIconInActive from '@/assets/sideBar/fx_inactive.png';

export const SideNavigationInfo = [
  {
    id: 1,
    title: '홈',
    uri: { active: homeIconActive, notActive: homeIcon },
    link: [routes.home, routes.notice, routes.noticeDetail],
  },
  {
    id: 11,
    title: '할인 등록',
    uri: { active: refundActiveIcon, notActive: refundIcon },
    link: [routes.discount],
  },
  {
    id: 12,
    title: '할인 내역',
    uri: { active: refundHistoryIconActive, notActive: refundHistoryIcon },
    link: [routes.discountDetail],
  },
  {
    id: 2,
    title: '환급하기',
    uri: { active: refundActiveIcon, notActive: refundIcon },
    link: [routes.refund],
  },
  {
    id: 3,
    title: '환급 내역',
    uri: { active: refundHistoryIconActive, notActive: refundHistoryIcon },
    link: [routes.refundDetail],
  },
  {
    id: 10,
    title: '현금 수납',
    uri: { active: fxIconActive, notActive: fxIconInActive },
    link: [routes.fxReceipt],
  },
  {
    id: 9,
    title: '해외 간편 결제',
    uri: { active: qrIconActive, notActive: qrIconInactive },
    link: [routes.globalPayment],
  },
  {
    id: 8,
    title: '예약 현황',
    uri: { active: bookStatusIconActive, notActive: bookStatusIconInactive },
    link: [routes.bookStatus],
  },
  {
    id: 4,
    title: '세무 자료',
    uri: { active: taxDataIconActive, notActive: taxDataIcon },
    link: [routes.refundStatement, routes.refundDeparture],
  },
  {
    id: 5,
    title: '키오스크 설정',
    uri: { active: kioskIconActive, notActive: kioskIcon },
    link: [routes.kiosk],
  },
  {
    id: 6,
    title: '배너 광고 설정',
    uri: { active: kioskIconActive, notActive: kioskIcon },
    link: [routes.ad],
  },
  {
    id: 7,
    title: '병원 정보',
    uri: { active: hospitalInfoIconActive, notActive: hospitalInfoIcon },
    link: [routes.medicalInfo],
  },
];

// TODO: 사이드메뉴 - 추후에 변경
// export const SideNavigationInfo = [
//   {
//     id: 1,
//     title: '홈',
//     uri: { active: homeIconActive, notActive: homeIcon },
//     link: [routes.home, routes.notice, routes.noticeDetail],
//   },
//   {
//     id: 2,
//     title: '환급하기',
//     uri: { active: refundActiveIcon, notActive: refundIcon },
//     link: [routes.refund],
//   },
//   {
//     id: 3,
//     title: '환급 내역',
//     uri: { active: refundHistoryIconActive, notActive: refundHistoryIcon },
//     link: [routes.refundDetail],
//   },
//   {
//     id: 4,
//     title: '세무 자료',
//     uri: { active: taxDataIconActive, notActive: taxDataIcon },
//     link: [routes.refundStatement, routes.refundDeparture],
//   },
// ];

// export const SideNavigationSettingList = [
//   {
//     id: 5,
//     title: '키오스크 설정',
//     uri: { active: kioskIconActive, notActive: kioskIcon },
//     link: [routes.kiosk],
//   },
//   {
//     id: 6,
//     title: '배너 광고 설정',
//     uri: { active: kioskIconActive, notActive: kioskIcon },
//     link: [routes.ad],
//   },
//   {
//     id: 7,
//     title: '병원 정보',
//     uri: { active: hospitalInfoIconActive, notActive: hospitalInfoIcon },
//     link: [routes.medicalInfo],
//   },
// ];

export const PACKAGE_LIST = [
  {
    key: 'LEFLAT',
    label: '리플렛',
    value: '리플렛',
    image: IMG_GOODS_LEFLAT,
    width: 30,
  },
  {
    key: 'REFUND_TABLE',
    label: '환급표',
    value: '환급표',
    image: IMG_GOODS_REFUND_TABLE,
    width: 36,
  },
  {
    key: 'STICKER',
    label: '스티커',
    value: '스티커',
    image: IMG_GOODS_STICKER,
    width: 40,
  },
  {
    key: 'POP',
    label: 'POP',
    value: 'pop',
    image: IMG_GOODS_POP,
    width: 22,
  },
  {
    key: 'ETC',
    label: '기타',
    value: '기타',
    image: IMG_GOODS_ETC,
    width: 22,
  },
];
